import { themeColor } from '@hud/web-components/theme/colors';
import { xsBold } from '@hud/web-components/theme/typography';
import styled from 'styled-components';
import { Button } from '@hud/web-components/Button/Button';

export const FooterActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex: 1;
  padding-block-start: 24px;
  padding-block-end: 20px;

  .left-actions,
  .right-actions {
    display: flex;
    gap: 10px;

    > button {
      height: 36px;
      padding: 10px 20px;
    }
  }
`;

export const StyledButton = styled(Button)`
  height: 36px;
  padding: 10px 20px;

  &.delete {
    color: ${themeColor('red')};
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  padding: 8px 12px;
  margin-block-start: 24px;
  margin-block-end: 20px;
  height: 36px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  ${xsBold};
  color: ${themeColor('textPrimary')};
  border: 1px solid ${themeColor('strokePrimary')};
  background: ${themeColor('buttonBackground')};
`;

export const ParametersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Separator = styled.div`
  border-top: 1px solid ${themeColor('strokeLight')};
  margin: 20px 0;
  width: 100%;
`;

export const ResetDefaultButton = styled(Button)`
  margin-top: 20px;
`;
